// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2yp9-","title":"Info_title__2V_4o","links":"Info_links__11R_z","link":"Info_link__3jGgc","logo":"Info_logo__3mgcN"};